module.exports = __webpack_public_path__ + "media/10x30.24d5eed0.png";